import React, { useEffect } from "react"
import { useFormik } from "formik"
import * as Yup from "yup"
import {
  getDefaultReceiptList,
  TRANSACTION_STATUS_PENDING_LIST,
} from "./fixture"
import axios from "axios"
import { useLocation } from "react-router-dom"
import { JSUtils } from "@utils"


// http://localhost:4003/receipts?realmId=digitmartdev&tenantId=1cc4e10f-1625-4934-8176-be3ca73e0fab&storeId=STR_TY_001
export let getDynamicAPI_URL = (props) => {
  let isLocalCheckSubSASS = false
  let apiEndpointEnv = process.env.REACT_APP_API_ENDPOINT
  const { location = {} } = window

  const { portal = true } = props || {}

  /**
   * @TODO_DYNAMIC
   */

  let domainHostName = location?.host.includes("localhost")
    ? isLocalCheckSubSASS
      ? "devdm.digitsquare.ai"
      : "devdm.digitmart.ai"
    : location?.host

  let portalLabel = portal ? "/portal" : ""
  return `https://api${domainHostName}${portalLabel}`
}

const doRootCss = () => {
  var cssValue = `
  :root {
    --receipt-header-bg: #000000;
    --receipt-button-color: #280b2b;
    --receipt-button-secondary-color: #a62991;
    --receipt-primary-color: #a62991;
    --receipt-primaryTextColor: #ffffff;
    --receipt-secondaryTextColor: #ffffff;
    --receipt-white-color: #ffffff;
    --receipt-tab-blue-color: #1e88e5;
    --receipt-blue-color: #e5f1ff;
    --receipt-mild-blue-color: #cbe4ff;
  }
 `

  var styleNode = document.createElement("style")
  styleNode.type = "text/css"
  if (!!(window.attachEvent && !window.opera)) {
    styleNode.styleSheet.cssText = cssValue
  } else {
    var styleText = document.createTextNode(cssValue)
    styleNode.appendChild(styleText)
  }
  document.querySelector("body").appendChild(styleNode)
}

const setFont = () => {
  // Preconnect fonts.googleapis.com
  const link1 = document.createElement("link")
  link1.rel = "preconnect"
  link1.href = "https://fonts.googleapis.com"
  document.head.appendChild(link1)

  // Preconnect fonts.gstatic.com
  const link2 = document.createElement("link")
  link2.rel = "preconnect"
  link2.href = "https://fonts.gstatic.com"
  link2.crossOrigin = "true"
  document.head.appendChild(link2)

  // Google Fonts stylesheet
  const link3 = document.createElement("link")
  link3.rel = "stylesheet"
  link3.href =
    "https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Roboto:ital,wght@0,100..900;1,100..900&display=swap"
  document.head.appendChild(link3)
}
const CUSTOMER_EMAIL_ERROR = "Please enter a valid email address"
const customerEmailSchema = Yup.string().trim().email().required()

const isValidCustomerEmail = (value = "") =>
  customerEmailSchema.isValidSync(value || "")

const useReceipt = () => {
  const getReceiptRef = React.useRef()
  const lastLookupValuesRef = React.useRef(null)

  const [getLoader, setLoader] = React.useState(false)
  const [getOpen, setOpen] = React.useState({ flag: false, message: "", severity: "", emailCaptureHidden: false })
  const [getCurrency, setCurrency] = React.useState("$")
  const [getLogoImage, setLogoImage] = React.useState("")
  const [getemailFocus, setemailFocus] = React.useState(true)
  const [getReceiptList, setReceiptList] = React.useState([{}])
  const [getReceiptCountryList, setReceiptCountryList] = React.useState([{}])
  const [getFlagFormSubmit, setFlagFormSubmit] = React.useState({
    flag: false,
    message: "",
  })
  const [getReceiptCountrySelected, setReceiptCountrySelected] = React.useState(
    ""
  )
  const [getDownloadingId, setDownloadingId] = React.useState("")
  const [getCustomerEmail, setCustomerEmail] = React.useState("")
  const [getCustomerEmailError, setCustomerEmailError] = React.useState("")
  const [getEmailSubmitting, setEmailSubmitting] = React.useState(false)
  let formikUI = null
  const location = useLocation()
  const params = new URLSearchParams(location.search)

  useEffect(() => {
    if (getLoader === true) {
      setCustomerEmail("")
      setCustomerEmailError("")
    }
  }, [getLoader])

  const getCountriesAndCurrency = async () => {
    let urlEndPoint = getDynamicAPI_URL({ portal: false })
    const { location = {} } = window || {}
    const parsedUrl = new URL(location.href || window.location.href)
    const queryParams = Object.fromEntries(parsedUrl.searchParams.entries())
    const realmId = queryParams?.realmId || "digitmartdev"
    try {
      const response = await axios.get(
        `${urlEndPoint}/mobile/content/api/countries/getCountriesAndCurrency`,
        {
          headers: {
            "x-kc-realm-id": realmId,
            "realm-id": realmId,
          },
        }
      )

      setReceiptCountryList(response.data?.data || [])
      return response.data
    } catch (error) {
      console.error("API Error:", error.response?.data || error.message)
      throw error
    }
  }

  React.useEffect(() => {
    JSUtils.getThemeKit({ setLogoImage, doRootCss })
    setFont()
    getCountriesAndCurrency()
    //TEMPORARY
  }, [])

  React.useEffect(() => { }, [])

  const onUpdateForm = (values) => { }

  const url = window?.location?.href || ""
  const parsedUrl = new URL(url)
  const queryParams = Object.fromEntries(parsedUrl.searchParams.entries())

  let defaultCountryCode = queryParams?.country_code || ""
  const [_getReceiptCountryItem = {}] = getReceiptCountryList?.filter(
    (itm) =>
      itm?.country_code?.toLocaleLowerCase() ===
      defaultCountryCode?.toLocaleLowerCase()
  )
  let defaultCountry = _getReceiptCountryItem?.country_name || ""

  let initialValues = {
    country: defaultCountry,
    payment_method: 0,
    // expiration_month: "02",
    // expiration_year: "2026",
    // date_store_visit: "2026-05-23",
    // last_four: "2211",
    expiration_month: "",
    expiration_year: "",
    date_store_visit: "",
    last_four: "",
  }

  let validationSchema = Yup.object({
    country: Yup.string().required("Country Required"),
    date_store_visit: Yup.string().required("Date of Store Visit required"),
    last_four: Yup.string()
      .matches(/^\d{4}$/, "Enter exactly 4 digits")
      .required("Last 4 digits required"),
    payment_method: Yup.string().required("Payment Required"),
    expiration_month: Yup.string().when("payment_method", {
      is: "0",
      then: Yup.string().notRequired(),
      // then: Yup.string().required("Select expiry month"),
      otherwise: Yup.string().notRequired(),
    }),

    expiration_year: Yup.string().when("payment_method", {
      is: "0",
      then: Yup.string().notRequired(),
      // then: Yup.string().required("Select expiry year"),
      otherwise: Yup.string().notRequired(),
    }),
  })

  const doDownloadPDF = async (urlKit = "", fileName = "file") => {
    const response = await fetch(urlKit)
    const blob = await response.blob()

    const url = window.URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = `${fileName}.pdf`
    document.body.appendChild(a)
    a.click()

    a.remove()
    setTimeout(() => {
      window.URL.revokeObjectURL(url)
    }, 4000)

  }

  const getAPIDownload = async (transactionItem) => {
    setemailFocus(false)
    const { transaction_id = "" } = transactionItem || {}
    console.log("transactionItem", transactionItem)
    let urlEndPoint = getDynamicAPI_URL()
    let constructURL = `${urlEndPoint}/hil/transaction/api/receipts/download/${transaction_id}`
    const { location = {} } = window || {}
    const url = location.href
    const parsedUrl = new URL(url)
    const queryParams = Object.fromEntries(parsedUrl.searchParams.entries())

    const [_getReceiptCountryItem = {}] =
      getReceiptCountryList?.filter(
        (itm) =>
          itm?.country_name?.toLocaleLowerCase() ===
          getReceiptCountrySelected?.toLocaleLowerCase()
      ) || []

    const country_Code_kit =
      _getReceiptCountryItem?.country_code || queryParams?.country_code || "US"

    let realmIdObj = transactionItem?.realmId
      ? { "realm-id": transactionItem?.realmId }
      : queryParams?.realmId
        ? { "realm-id": queryParams?.realmId }
        : {}
    let tenantId = transactionItem?.tenantId
      ? { "tenant-id": transactionItem?.tenantId }
      : queryParams?.tenantId
        ? { "tenant-id": queryParams?.tenantId }
        : {}

    let storeId = transactionItem?.store?.store_id
      ? { "store-id": transactionItem?.store?.store_id }
      : queryParams?.storeId
        ? { "store-id": queryParams?.storeId }
        : {}

    try {
      const config = {
        method: "post",
        url: constructURL,
        headers: {
          "Content-Type": "application/json",
          ...realmIdObj,
          ...tenantId,
          ...storeId,
          country_code: country_Code_kit || "US",
          "country-code": country_Code_kit || "US",
        },
        data: {
          transaction_id: transaction_id || "",
          transaction_status: transactionItem?.transaction_status || "",
          customer_exited_local_datetime:
            transactionItem?.detail?.customer_exited_local_datetime || "",
          cart_items_count: transactionItem?.carts?.[0]?.items?.length || 0,
          store: {
            store_name: transactionItem?.store?.store_name || "",
            store_support_email:
              transactionItem?.store?.store_support_email || "",
            product_return_policy:
              transactionItem?.store?.product_return_policy || "",
            address: transactionItem?.store?.address || {},
            phone_number: transactionItem?.store?.phone_number || {
              country_code: "",
              number: "",
            },
            tenant_config_details: {
              tenant_logo:
                transactionItem?.store?.tenant_config_details?.tenant_logo ||
                "",
            },
          },
          cart: transactionItem?.carts?.[0] || {},
          discount: transactionItem?.discount || {
            show_discount: false,
            is_percentage: false,
            discount_value: 0,
            discount_name: "",
          },
        },
      }

      const response = await axios(config)
      let responseKit = response?.data || []
      let responseKitData = responseKit?.receipt_url
      doDownloadPDF(responseKitData, `PDF_${transaction_id}`)
      // if (responseKit.length > 0) {
      //   let responseKitData = responseKit?.receipt_url
      //   doDownloadPDF(responseKitData, `PDF_${transaction_id}`)
      // }
    } catch (error) {
      handleClick(getFailedAPIMessage(error, "API Failed"), "error")
    }
  }

  const handleDownloadToReceipt = async (transactionItem, e) => {
    const { transaction_id = "" } = transactionItem || {}
    setDownloadingId(transaction_id)
    try {
      await getAPIDownload(transactionItem)
    } finally {
      setDownloadingId("")
    }
  }
  const handleBackToReceipt = (formKit) => {
    const is_tenant = window.location.href.includes('country_code')
    setReceiptList([{}])
    setCustomerEmail("")
    setCustomerEmailError("")
    setOpen((prev) => ({ ...prev, emailCaptureHidden: false }))
    const restoredCountry =
      getReceiptCountrySelected ||
      formKit?.values?.country ||
      defaultCountry ||
      ""
    if (!is_tenant) {
      formKit?.resetForm({
        values: {
          ...initialValues,
          country: ""
        },
      })
    }
    else {
      formKit?.resetForm({
        values: {
          ...initialValues,
          country: restoredCountry,
        },
      })
    }
    if (restoredCountry && is_tenant) {
      setReceiptCountrySelected(restoredCountry)
    }
    if (!is_tenant) {
      setReceiptCountrySelected("")
    }
    formikUI?.setFieldValue("payment_method", 0)
    setFlagFormSubmit({
      flag: false,
      message: "",
    })
  }

  const cf = {
    1: "list-available",
    2: "No receipts found. Check your date and card details.",
    3: "Thanks for visiting. Your receipt will be ready soon.",
    // "3": "The receipt will be sent to your email ID shortly",
  }

  const getAPIFormSubmit = async (values) => {
    lastLookupValuesRef.current = values
    setLoader(true)
    let urlEndPoint = getDynamicAPI_URL()
    let constructURL = `${urlEndPoint}/hil/transaction/api/receipts/lookup`
    const { location = {} } = window || {}
    const url = location.href
    const parsedUrl = new URL(url)
    const queryParams = Object.fromEntries(parsedUrl.searchParams.entries())

    const selectedCountryName =
      values?.country || getReceiptCountrySelected || ""
    const [_getReceiptCountryItem = {}] =
      getReceiptCountryList?.filter(
        (itm) =>
          itm?.country_name?.toLocaleLowerCase() ===
          selectedCountryName?.toLocaleLowerCase()
      ) || []

    const country_Code_kit =
      _getReceiptCountryItem?.country_code || queryParams?.country_code || "US"

    let realmIdObj = queryParams?.realmId
      ? { "realm-id": queryParams?.realmId }
      : {}
    let tenantId = queryParams?.tenantId
      ? { "tenant-id": queryParams?.tenantId }
      : {}
    let storeId = queryParams?.storeId
      ? { "store-id": queryParams?.storeId }
      : {}

    const config = {
      method: "post",
      url: constructURL,
      headers: {
        "Content-Type": "application/json",
        ...realmIdObj,
        ...tenantId,
        ...storeId,
        country_code: country_Code_kit || "US",
        "country-code": country_Code_kit || "US",
      },
      data: {
        visit_date: values.date_store_visit,
        card_last4: values.last_four,
        card_expiry:
          Number(values.expiration_month) === 0
            ? ""
            : Number(values.expiration_month) +
            "-" +
            Number(values.expiration_year),
      },
    }

    axios(config)
      .then((response) => {
        // let dataKit_c = JSON.stringify(response?.data)
        // dataKit_c = JSON.parse(dataKit_c)
        // dataKit_c[0]["transaction_id"] = "1779543173235"
        // dataKit_c[0]["status_group"] = "Reviewed Disputes"
        // dataKit_c[0]["transaction_status"] = "Dispute Reviewed"

        // let dataKit = JSON.stringify(response?.data)
        // dataKit = JSON.parse(dataKit)
        // dataKit[0]["transaction_id"] = "1779543173234"
        // let responseKit = [...response?.data, ...dataKit, ...dataKit_c] || []
        let responseKit = response?.data || []

        console.log("responseKit", responseKit)
        if (responseKit.length > 0) {
          if (responseKit.length > 0) {
            setTimeout(() => {
              setLoader(false)
              window.scrollTo({
                top: (getReceiptRef?.current?.offsetTop || 530) - 80,
                behavior: "smooth",
              })
            }, 3000)
            setReceiptList(getDefaultReceiptList(responseKit))
            setFlagFormSubmit({
              flag: false,
              message: "",
            })
          } else {
            setLoader(false)
            setReceiptList([])
            setFlagFormSubmit({
              flag: true,
              message: cf["2"],
            })
          }
        } else {
          // handleClick("API Failed 2", "error")
          setLoader(false)
          setReceiptList([])
          setFlagFormSubmit({
            flag: true,
            message: "No receipts found. Check your date and card details.",
          })
        }
      })
      .catch((err) => {
        setLoader(false)
        setReceiptList([])
        setFlagFormSubmit({
          flag: true,
          message: getFailedAPIMessage(
            err,
            "Unable to find your receipt. Please try again."
          ),
        })
      })
  }

  const onSubmit = (values) => {
    console.log("Submitted:", values)
    setOpen((prev) => ({ ...prev, emailCaptureHidden: false }))
    getAPIFormSubmit(values)
  }
  const handleClick = (message = "", severity = "") => {
    const isEmailSuccess =
      severity === "success" &&
      message === "We'll email your receipt once it's ready."
    setOpen((prev) => ({
      ...prev,
      flag: true,
      message,
      severity,
      emailCaptureHidden: isEmailSuccess ? true : prev.emailCaptureHidden,
    }))

    setTimeout(() => {
      handleClose()
    }, 5000)
  }

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return
    setOpen((prev) => ({ ...prev, flag: false, message: "", emailCaptureHidden: prev.emailCaptureHidden }))
  }

  const getFailedAPIMessage = (error, defaultMessage) => {
    const apiMessage = error?.response?.data?.message
    return typeof apiMessage === "string" && apiMessage.trim()
      ? apiMessage.trim()
      : defaultMessage
  }

  const isPendingReceiptStatus = (transactionStatus = "") =>
    TRANSACTION_STATUS_PENDING_LIST.some(
      (status) =>
        status.toLowerCase() === String(transactionStatus || "").toLowerCase()
    )

  const getReceiptRequestHeaders = (transactionItem) => {
    const { location = {} } = window || {}
    const parsedUrl = new URL(location.href || window.location.href)
    const queryParams = Object.fromEntries(parsedUrl.searchParams.entries())
    const selectedCountryName = getReceiptCountrySelected || ""
    const [_getReceiptCountryItem = {}] =
      getReceiptCountryList?.filter(
        (itm) =>
          itm?.country_name?.toLocaleLowerCase() ===
          selectedCountryName?.toLocaleLowerCase()
      ) || []
    const country_Code_kit =
      _getReceiptCountryItem?.country_code || queryParams?.country_code || "US"
    const realmId = transactionItem?.realmId || queryParams?.realmId
    const tenantId = transactionItem?.tenantId || queryParams?.tenantId
    const storeId = transactionItem?.store?.store_id || queryParams?.storeId

    return {
      accept: "*/*",
      "Content-Type": "application/json",
      ...(realmId ? { "realm-id": realmId } : {}),
      ...(tenantId ? { "tenant-id": tenantId } : {}),
      ...(storeId ? { "store-id": storeId } : {}),
      country_code: country_Code_kit || "US",
      "country-code": country_Code_kit || "US",
    }
  }

  const onCustomerEmailChange = (value = "") => {
    setemailFocus(true)
    setCustomerEmail(value)
    const email = String(value || "").trim()
    if (!email || isValidCustomerEmail(email)) {
      setCustomerEmailError("")
      return
    }
    const atIndex = email.indexOf("@")
    const domain = atIndex >= 0 ? email.slice(atIndex + 1) : ""
    const looksComplete = atIndex > 0 && domain.includes(".")
    if (looksComplete || getCustomerEmailError) {
      setCustomerEmailError(CUSTOMER_EMAIL_ERROR)
    }
  }

  const onCustomerEmailBlur = () => {
    setemailFocus(true)
    const email = String(getCustomerEmail || "").trim()
    if (!email || isValidCustomerEmail(email)) {
      setCustomerEmailError("")
      return
    }
    setCustomerEmailError(CUSTOMER_EMAIL_ERROR)
  }

  const onSubmitCustomerEmail = async () => {
    const email = (getCustomerEmail || "").trim()
    if (!isValidCustomerEmail(email)) {
      setCustomerEmailError(CUSTOMER_EMAIL_ERROR)
      return
    }

    const pendingReceipts = []
    const seenTransactionIds = new Set()

    console.log("getReceiptList", getReceiptList)
      ; (getReceiptList || []).forEach((item) => {
        const transactionId = item?.transaction_id || item?.transactionId
        if (
          !transactionId ||
          seenTransactionIds.has(transactionId) ||
          !isPendingReceiptStatus(item?.transaction_status)
        ) {
          return
        }
        seenTransactionIds.add(transactionId)
        pendingReceipts.push(item)
      })

    if (pendingReceipts.length === 0) {
      handleClick("Unable to update email for this receipt.", "error")
      return
    }

    setCustomerEmailError("")
    setEmailSubmitting(true)
    const urlEndPoint = getDynamicAPI_URL()

    console.log("pendingReceipts", pendingReceipts)
    try {
      setemailFocus(true)
      await Promise.all(
        pendingReceipts.map((item) => {
          const transactionId = item?.transaction_id || item?.transactionId
          return axios({
            method: "post",
            url: `${urlEndPoint}/hil/transaction/api/receipts/customer/email/update/${encodeURIComponent(
              transactionId
            )
              }`,
            headers: getReceiptRequestHeaders(item),
            data: {
              customer_email: email,
            },
          })
        })
      )
      handleClick("We'll email your receipt once it's ready.", "success")
      await setCustomerEmail("")
    } catch (error) {
      // handleClick(
      //   getFailedAPIMessage(error, "Unable to save email. Please try again."),
      //   "error"
      // )
      handleClick("Your receipt is ready. Download it here.", "success")

    } finally {
      setEmailSubmitting(false)
      if (lastLookupValuesRef.current) {
        getAPIFormSubmit(lastLookupValuesRef.current)
      }
    }
  }

  const getShowEmailCapture =
    !getOpen.emailCaptureHidden &&
    (getReceiptList || []).some((item) =>
      isPendingReceiptStatus(item?.transaction_status)
    )
  const onUpdateTab = (tabProps, formikUI) => {
    const restoredCountry =
      getReceiptCountrySelected ||
      formikUI?.values?.country ||
      defaultCountry ||
      ""
    formikUI?.resetForm({
      values: {
        ...initialValues,
        country: restoredCountry,
      },
    })
    setTimeout(() => {
      formikUI?.setFieldValue("payment_method", tabProps?.index)
      setReceiptList([{}])
    }, 5000)
  }
  return {
    onUpdateTab,
    getLogoImage,
    setLogoImage,
    getLoader,
    initialValues,
    validationSchema,
    setLoader,
    onSubmit,
    getReceiptList,
    setFlagFormSubmit,
    getFlagFormSubmit,
    handleBackToReceipt,
    getCurrency,
    cf,
    getReceiptRef,
    handleDownloadToReceipt,
    getDownloadingId,
    getOpen,
    setOpen,
    handleClose,
    getReceiptCountryList,
    setReceiptCountryList,
    setReceiptCountrySelected,
    getShowEmailCapture,
    getCustomerEmail,
    getemailFocus,
    setemailFocus,
    setCustomerEmail,
    getCustomerEmailError,
    setCustomerEmailError,
    getCustomerEmailSubmitDisabled:
      getEmailSubmitting || !isValidCustomerEmail(getCustomerEmail),
    onCustomerEmailChange,
    onCustomerEmailBlur,
    getEmailSubmitting,
    onSubmitCustomerEmail,
  }
}

export { useReceipt }
export default useReceipt
